// extracted by mini-css-extract-plugin
module.exports = {"topArtists":"_topArtists_topArtists__u8wJI"};